import { render, staticRenderFns } from "./HeaderLunbo.vue?vue&type=template&id=1267081d&scoped=true"
import script from "./HeaderLunbo.vue?vue&type=script&lang=js"
export * from "./HeaderLunbo.vue?vue&type=script&lang=js"
import style0 from "./HeaderLunbo.vue?vue&type=style&index=0&id=1267081d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267081d",
  null
  
)

export default component.exports